import React from 'react'
import { Base, TermsOfUseContent } from '../components'

const TermsOfUse = (): JSX.Element => (
  <Base
    headKey={'Terms of Use'}
    title={'Terms of Use | NorthOne'}
    metaDescription="These terms of use is the agreement you make by accessing our website. The materials contained are protected by applicable copyright and trademark law."
  >
    <TermsOfUseContent />
  </Base>
)

export default TermsOfUse
